<form class="orderForm" #orderForm="ngForm">
  @if (order(); as order) {
    <div class="toolbar">
      <span>
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="backToOrderMaster()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <label class="buttonLabel">Back To Search</label>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
      <span>
        @if (order.updateAllowed && order.projectProductType === ProjectProductType.COM) {
          <button matButton="text" class="toolbarButton"
            [matMenuTriggerFor]="projectActionsMenu">
            <span>
              <label class="buttonLabel">Project Defaults</label>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #projectActionsMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="openProjectDefaultsScreen()">
            <mat-icon class="size-12">dashboard</mat-icon>
            <label class="buttonLabel">Project Level Information</label>
          </button>
        </mat-menu>
        @if (order.updateAllowed) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()"
            [matMenuTriggerFor]="pricingMenu">
            <span>
              <label class="buttonLabel">Pricing</label>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #pricingMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="multiplier()">
            <mat-icon class="size-12">keyboard</mat-icon>
            <label class="buttonLabel">Multiplier</label>
          </button>
          @if (showFpaManagementButton()) {
            <button class="menuButton" mat-menu-item (click)="fpaManagement()">
              <mat-icon class="size-12">attach_money</mat-icon>
              <label class="buttonLabel">Request FPA</label>
            </button>
          }
          @if (showFpaCancelButton()) {
            <button class="menuButton" mat-menu-item (click)="cancelFpaReview()">
              <mat-icon class="size-12">cancel</mat-icon>
              <label class="buttonLabel">Cancel FPA Review</label>
            </button>
          }
          @if (userHasRole('IT') || userHasRole('CustomerService')) {
            <button class="menuButton" mat-menu-item
              (click)="viewEntityBreaks()">
              <mat-icon class="size-12">subject</mat-icon>
              <label class="buttonLabel">Order Breaks</label>
            </button>
          }
          @if (canUpdateExtendedWarranty()) {
            <button class="menuButton" mat-menu-item
              (click)="showExtendedWarrantyDialog()">
              <mat-icon class="size-12">verified</mat-icon>
              <label class="buttonLabel">Extended Warranty</label>
            </button>
          }
          @if (isInternalOrRsm()) {
            <button class="menuButton" mat-menu-item (click)="openCostReport()">
              <mat-icon class="size-12">request_quote</mat-icon>
              <label class="buttonLabel">Cost Report</label>
            </button>
          }
        </mat-menu>
        @if (order.updateAllowed) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()"
            [matMenuTriggerFor]="actionsMenu">
            <span>
              <label class="buttonLabel">Actions</label>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #actionsMenu="matMenu" [overlapTrigger]="false">
          @if (isBlanket() && (userHasRole('IT') || userHasRole('CustomerService'))) {
            <button class="menuButton"
              mat-menu-item (click)="generateRevision()">
              <mat-icon class="size-12">archive</mat-icon>
              <label class="buttonLabel">Generate Revision</label>
            </button>
          }
          @if (showCancel()) {
            <button class="menuButton" mat-menu-item (click)="cancel()">
              <mat-icon class="size-12">do_not_disturb</mat-icon>
              <label class="buttonLabel">Cancel</label>
            </button>
          }
          @if (showIecRelease()) {
            <button class="menuButton" mat-menu-item (click)="releasePendingApproval()">
              <mat-icon class="size-12">send</mat-icon>
              <label class="buttonLabel">Release</label>
            </button>
          }
          <!--<button *ngIf="canRelease()" class="menuButton" mat-menu-item (click)="generateRelease()"
          [disabled]="mockupPending()" matTooltip="Mockup Pending Approval" [matTooltipDisabled]="!mockupPending()">
          <mat-icon class="size-12">create_new_folder</mat-icon>
          <label class="buttonLabel">Generate Release</label>
        </button> -->
        @if (canScheduleRelease()) {
          <button class="menuButton" mat-menu-item (click)="scheduleReleases()"
            [disabled]="mockupPending()" matTooltip="Mockup Pending Approval" [matTooltipDisabled]="!mockupPending()">
            <mat-icon class="size-12">create_new_folder</mat-icon>
            <label class="buttonLabel">Schedule Ship Dates</label>
          </button>
        }
        @if (readyForScheduling()) {
          <button class="menuButton" mat-menu-item (click)="sendToScheduling()">
            <mat-icon class="size-12">insert_invitation</mat-icon>
            <label class="buttonLabel">Scheduling</label>
          </button>
        }
        @if (isAcknowledgmentReady()) {
          <button class="menuButton" mat-menu-item (click)="sendAcknowledgment()">
            <mat-icon class="size-12">mail</mat-icon>
            <label class="buttonLabel">Send Acknowledgment</label>
          </button>
        }
        @if (userHasRole('IT') || userHasRole('CustomerService')) {
          <button class="menuButton" mat-menu-item
            (click)="fixPermissions()">
            <mat-icon class="size-12">lock_open</mat-icon>
            <label class="buttonLabel">Fix Permissions</label>
          </button>
        }
        @if (userHasRole('IT') || userHasRole('IECQEWLAdmin')) {
          <button class="menuButton" mat-menu-item
            (click)="openQewlDialog()">
            <mat-icon class="size-12">layers</mat-icon>
            <label class="buttonLabel">QEWL</label>
          </button>
        }
        @if (showUnrestrictedEditOption()) {
          <button class="menuButton" mat-menu-item (click)="showUnrestrictedChangesDialog()">
            <mat-icon class="size-12">edit</mat-icon>
            <span class="buttonLabel">Update Approved Order</span>
          </button>
        }
      </mat-menu>
      @if (showSfrActions()) {
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()"
          [matMenuTriggerFor]="sfrMenu">
          <span>
            <label class="buttonLabel">SFR Actions</label>
            <mat-icon class="size-16">arrow_drop_down</mat-icon>
          </span>
        </button>
      }
      <mat-menu #sfrMenu="matMenu" [overlapTrigger]="false">
        <button class="menuButton" mat-menu-item (click)="sfrManagement()">
          <mat-icon class="size-12">local_grocery_store</mat-icon>
          <label class="buttonLabel">SFR Management</label>
        </button>
        @if (canSubmitSfrs()) {
          <button class="menuButton" mat-menu-item (click)="submitSfr()">
            <mat-icon class="size-12">event_available</mat-icon>
            <label class="buttonLabel">Submit SFR</label>
          </button>
        }
        @if (canCancelSfrs()) {
          <button class="menuButton" mat-menu-item (click)="cancelSfr()">
            <mat-icon class="size-12">not_interested</mat-icon>
            <label class="buttonLabel">Cancel Review</label>
          </button>
        }
      </mat-menu>
        @if (showSpecialQuotes()) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="specialQuotes()">
            <span>
              <span class="buttonLabel">Special Quotes</span>
            </span>
          </button>
        }
      <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="viewDocuments()">
        <span>
          <mat-icon class="size-16">content_copy</mat-icon>
          <label class="buttonLabel">Docs</label>
        </span>
      </button>
      <button matButton="text" class="toolbarButton" [disabled]="isBusy()" [matMenuTriggerFor]="viewMenu">
        <span>
          <label class="buttonLabel">View</label>
          <mat-icon class="size-16">arrow_drop_down</mat-icon>
        </span>
      </button>
      <mat-menu #viewMenu="matMenu" [overlapTrigger]="false">
        @if (order.associatedQuoteId && order.associatedQuoteId.length > 0) {
          <button class="menuButton" mat-menu-item
            (click)="viewQuote()">
            <mat-icon class="size-12">attach_file</mat-icon>
            <label class="buttonLabel">Quote</label>
          </button>
        }
        @if (order.associatedOrderId && order.associatedOrderId.length > 0) {
          <button class="menuButton" mat-menu-item
            (click)="viewBlanket()">
            <mat-icon class="size-12">attach_file</mat-icon>
            <label class="buttonLabel">Order</label>
          </button>
        }
        @if (associatedOrders() && associatedOrders().length > 0) {
          <button class="menuButton" mat-menu-item
            (click)="viewReleaseSummary()">
            <mat-icon class="size-12">attach_file</mat-icon>
            <label class="buttonLabel">Release Summary</label>
          </button>
        }
        <button class="menuButton" mat-menu-item (click)="showEntityHistoryDialog()">
          <mat-icon class="size-12">history</mat-icon>
          <span class="buttonLabel">History</span>
        </button>
        @if (isBlanket()) {
          <a class="menuLink" mat-menu-item
            [routerLink]="['/sabrSummary/' + order.projectNumber, order.id.entityId, order.customerId]" target="_blank">
            <mat-icon class="size-12">attach_file</mat-icon>
            <label class="buttonLabel">Summary</label>
          </a>
        }
        @if (!isBlanket()) {
          <button class="menuButton" mat-menu-item (click)="viewProcessingStatus()">
            <mat-icon class="size-12">date_range</mat-icon>
            <label class="buttonLabel">Processing Status</label>
          </button>
        }
        @if (isBlanket() && (userHasRole('IT') || userHasRole('CustomerService'))) {
          <button class="menuButton"
            mat-menu-item (click)="getRevisionChangeReport()">
            <mat-icon class="size-12">request_quote</mat-icon>
            <label class="buttonLabel">Run Change Report</label>
          </button>
        }
      </mat-menu>
      <mat-menu #associatedOrdersMenu="matMenu">
        @for (order of associatedOrders(); track order) {
          <button class="menuButton" mat-menu-item (click)="viewOrder(order)">
            <label class="buttonLabel">{{ order.entityId }};{{ order.entityRevision }}</label>
          </button>
        }
      </mat-menu>
      @if (order.updateAllowed) {
        <button matButton="text" class="toolbarButton" [disabled]="isBusy() || !orderForm.valid || isErpLocked()"
          (click)="save()">
          <span>
            <mat-icon class="size-16">save</mat-icon>
            <label class="buttonLabel">Save</label>
          </span>
        </button>
      }
      @if (isOrderReviewable()) {
        <button matButton="text" class="toolbarButton orderReviewButton"
          [disabled]="isBusy() || !canSubmitForReview()" (click)="submitForReview()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label class="buttonLabel">Submit For Review</label>
          </span>
        </button>
      }
      @if (canSubmitOrder()) {
        <button matButton="text" class="toolbarButton orderReviewButton" [disabled]="isBusy()"
          (click)="submitOrderToBackEndSystemsAfterScheduledReleaseDatesApplied()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label class="buttonLabel">Submit Order</label>
          </span>
        </button>
      }
    </span>
  </div>
}
@if (errorMessages() && errorMessages().length > 0) {
  <div class="errorMessage">
    <pre>{{ createErrorMessage() }}</pre>
  </div>
}
@if (saveMessages() && saveMessages().length > 0) {
  <div class="saveMessage">
    @for (message of saveMessages(); track message) {
      <div>
        {{ message }}
      </div>
    }
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">{{ waitMessage() }}</label>
    </div>
  </div>
}
@if (order(); as order) {
  <div class="orderDetail">
    <div class="thirdColumn">
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Order Information</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td class="rightAligned labelColumn"><label>OrderID:</label></td>
              <td class="dataColumn"><label>{{ order.id.entityId }};{{ order.id.entityRevision }}</label></td>
            </tr>
            <!-- <tr>
            <td class="rightAligned labelColumn"><label>IEC Project #:</label></td>
            <td class="dataColumn">
              <input id="projectNumberInput" name="projectNumberInput"
                *ngIf="userHasRole('IT') || userHasRole('CredAnalyst')" class="standardTextBox inputField"
                maxlength="8" [(ngModel)]="order.projectNumber"/>
              <label *ngIf="!userHasRole('IT') && !userHasRole('CredAnalyst')">{{ order.projectNumber }}</label>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>IEC Release #:</label></td>
            <td class="dataColumn">
              <input id="releaseNumberInput" name="releaseNumberInput"
                *ngIf="userHasRole('IT') || userHasRole('CredAnalyst')" class="standardTextBox inputField"
                maxlength="6" [(ngModel)]="order.releaseNumber"/>
              <label *ngIf="!userHasRole('IT') && !userHasRole('CredAnalyst')">{{ order.releaseNumber }}</label>
            </td>
          </tr> -->
          <tr>
            <td class="rightAligned labelColumn"><label for="projectNameInput">Project Name:</label></td>
            <td class="dataColumn">
              <input id="projectNameInput" name="projectNameInput" class="inputField standardTextBox" maxlength="30"
                [ngClass]="{'inputError': projectNameInput.invalid}" required [(ngModel)]="order.projectName"
                #projectNameInput="ngModel"/>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn">CLM Order ID:</td>
            <td class="dataColumn"><label>{{ this.determineClmOrderid() }}</label></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>ERP Order ID:</label></td>
            <td class="dataColumn"><label>{{ order.erpOrderNumber || ' Not Available ' }}</label></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>Brand:</label></td>
            <td class="dataColumn"><label>{{ this.selectedBrand() }}</label></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label for="customerSelection">Customer:</label></td>
            <td class="dataColumn">
              <select id="customerSelection" name="customerSelection" class="inputField"
                [(ngModel)]="order.customerId">
                @for (customer of customers(); track customer) {
                  <option [ngValue]="customer.code">{{ customer.description }}
                  </option>
                }
              </select>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>Rep Office:</label></td>
            <td class="dataColumn">
              <label>{{ sellingOrgDescription() }}</label>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>Release Type:</label></td>
            <td class="dataColumn">
              <label>{{ getReleaseType() }}</label>
            </td>
          </tr>
          @if (userHasRole('CustomerService') || userHasRole('IT') || userHasRole('CredAnalyst') || userHasRole('ApplicationEngineer') || userHasRole('RSM') ) {
            <tr
              >
              <td colspan="2">
                <textarea name="internalNotesInput" rows="3" class="noresize fullWidth"
                [(ngModel)]="order.internalNotes" placeholder="Internal Notes"></textarea>
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
    <div class="infoPanel">
      <div class="panelHeader">
        <label>Processing and Contacts</label>
      </div>
      <div class="panelBody">
        <table class="layoutTable">
          <tr>
            <td class="rightAligned labelColumn"><label>Est Ship Date:</label></td>
            <td class="dataColumn">
              @if (userHasRole('IT') || userHasRole('CustomerService')) {
                <div>
                  <input [matDatepicker]="shipDatePicker" name="shipDateInput"
                    [value]="formatDisplayDate(order.estimatedScheduleDate)"
                    (dateChange)="setShipDate($event.value)"/>
                  <mat-datepicker-toggle [for]="shipDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker id="shipDatePicker" name="shipDatePicker" #shipDatePicker></mat-datepicker>
                </div>
              }
              @if (!userHasRole('IT') && !userHasRole('CustomerService')) {
                <label>{{
                  order.estimatedScheduleDate
                  | date:'MM/dd/yyyy':'UTC'
                }}</label>
              }
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>FOB:</label></td>
            <td class="dataColumn">
              @if (userHasRole('IT') || userHasRole('CustomerService')) {
                <div
                  [ngClass]="{'selectionError': fobCodeInput.invalid}">
                  <select name="fobCodeInput" class="inputField" required [(ngModel)]="order.fobCode"
                    #fobCodeInput="ngModel">
                    <option value="undefined" disabled>Please Select</option>
                    @for (fob of fobs(); track fob) {
                      <option [ngValue]="fob.code">{{ fob.description }}</option>
                    }
                  </select>
                </div>
              }
              @if (!userHasRole('IT') && !userHasRole('CustomerService')) {
                <label>{{ order.fobCode }}</label>
              }
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>Order Info:</label></td>
            <td class="dataColumn">
              @if (userHasRole('IT') || userHasRole('CustomerService')) {
                <div>
                  <input name="orderInfoInput" class="inputField standardTextBox" maxlength="10"
                    [(ngModel)]="order.orderInfo" #orderInfoInput/>
                </div>
              }
              @if (!userHasRole('IT') && !userHasRole('CustomerService')) {
                <div>
                  <label>{{ order.orderInfo }}</label>
                </div>
              }
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>Payment Terms:</label></td>
            <td class="dataColumn">
              @if (userHasRole('IT') || userHasRole('CustomerService')) {
                <div
                  [ngClass]="{'selectionError': paymentTermsInput.invalid}">
                  <select name="paymentTermsInput" class="inputField" required [(ngModel)]="order.paymentTermsCode"
                    #paymentTermsInput="ngModel">
                    <option value="undefined" disabled>Please Select</option>
                    @for (paymentTerm of paymentTerms(); track paymentTerm) {
                      <option [ngValue]="paymentTerm.code">
                        {{ paymentTerm.description }}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (!userHasRole('IT') && !userHasRole('CustomerService')) {
                <label
                >{{ order.paymentTermsCode }}</label>
              }
            </td>
          </tr>
          <tr>
            <td class="rightAligned">
              <span class="repSelection" (click)="showSalesRep()">
                Sales Rep:
              </span>
            </td>
            <td class="dataColumn">
              <div [ngClass]="{'selectionError': salesRepIdInput.invalid}">
                <select id="salesRepIdInput" name="salesRepIdInput" class="inputField" required
                  [(ngModel)]="order.salesRepId" #salesRepIdInput="ngModel">
                  <option value="undefined" disabled>Please Select</option>
                  @for (salesRep of salesReps(); track salesRep) {
                    <option [ngValue]="salesRep.code">{{ salesRep.description }}
                    </option>
                  }
                </select>
              </div>
            </td>
          </tr>
          @if (order.totalQuoteAmount > 50000) {
            <tr>
              <td class="rightAligned labelColumn"><label for="outsideSalesRepIdInput">Outside Sales
              Rep:</label></td>
              <td class="dataColumn">
                <div [ngClass]="{'selectionError': outsideSalesRepIdInput.invalid}">
                  <select id="outsideSalesRepIdInput" name="outsideSalesRepIdInput" class="inputField"
                    [required]="order.totalQuoteAmount > 50000" [(ngModel)]="order.outsideSalesRepId"
                    #outsideSalesRepIdInput="ngModel">
                    <option value="undefined" disabled>Please Select</option>
                    @for (salesRep of outsideSalesReps(); track salesRep) {
                      <option [ngValue]="salesRep.code">
                        {{ salesRep.description }}
                      </option>
                    }
                  </select>
                </div>
              </td>
            </tr>
          }
          <tr>
            <td class="rightAligned labelColumn">
              <label>SFR Price Date:</label>
            </td>
            <td class="dataColumn">
              @if (userHasRole('IT')) {
                <div>
                  <input [matDatepicker]="sfrPriceDatePicker" name="sfrPriceDateInput"
                    [value]="formatDisplayDate(order.sfrPriceBasisDate)"
                    (dateChange)="setSfrPriceDate($event.value)"/>
                  <mat-datepicker-toggle [for]="sfrPriceDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker id="sfrPriceDatePicker" name="sfrPriceDatePicker" #sfrPriceDatePicker>
                  </mat-datepicker>
                </div>
              }
              @if (!userHasRole('IT')) {
                <label>{{ order.sfrPriceBasisDate | date:'MM/dd/yyyy':'UTC' }}</label>
              }
            </td>
          </tr>
          <tr>
            <td class="rightAligned">
              <span class="repSelection" (click)="showIecContact()">
                Contact:
              </span>
            </td>
            <td class="dataColumn">
              @if (userHasRole('CustomerService') || userHasRole('IT') || userHasRole('CredAnalyst') || userHasRole('ApplicationEngineer') || userHasRole('RSM')) {
                <div
                  [ngClass]="{'selectionError': iecContactIdInput.invalid}">
                  <select name="iecContactIdInput" class="inputField" required [(ngModel)]="order.iecContactId"
                    #iecContactIdInput="ngModel">
                    <option value="null" disabled>Please Select</option>
                    @for (iecContact of iecContacts(); track iecContact) {
                      <option [ngValue]="iecContact.code"
                        >{{ iecContact.description }}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (!userHasRole('CustomerService') && !userHasRole('IT') && !userHasRole('CredAnalyst') && !userHasRole('ApplicationEngineer') && !userHasRole('RSM')) {
                <label
                >{{ order.iecContactDescription }}</label>
              }
            </td>
          </tr>
          @if (order.skyportServicePresent) {
            <tr>
              <td [ngClass]="{'skyportError': skyportContactMissing()}" class="rightAligned">
                <span class="repSelection" (click)="selectSkyportContact()">
                  Skyport Contact
                </span>
              </td>
            </tr>
          }
          <tr>
            <td class="rightAligned labelColumn"><label>Last Process Date:</label></td>
            <td class="dataColumn"><label>{{ order.lastProcessDate | date:'MM/dd/yyyy':'UTC' }}</label></td>
          </tr>
          <tr>
            <td colspan="2"><label>Created: {{ createdBy() }} -
            {{ order.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
          </tr>
          <tr>
            <td colspan="2"><label>Updated: {{ updatedBy() }} -
            {{ order.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="thirdColumn">
    <div class="infoPanel">
      <div class="panelHeader">
        <label>Pricing Controls</label>
      </div>
      <div class="panelBody">
        <table class="layoutTable">
          <tr>
            <td>
              @if (showWarrantyTextLink()) {
                <span class="warrantyTextSelection" (click)="showWarrantyText()">
                  Warranty Text
                </span>
              }
            </td>
            <td class="rightAligned labelColumn"><label>Lead Time:</label></td>
            <td class="dataColumn">
              @if (isStockProgram()) {
                <label>{{ leadTimeDescription() }}</label>
              }
              @if (!LeadTimeUtils.validWarrantyLeadTime(order.leadTimeCode, order.brandID) && order.leadTimeCode !== 'SLC' && !isStockProgram()) {
                <div>
                  <select name="leadTimeCodeInput" class="inputField" [(ngModel)]="order.leadTimeCode"
                    (change)="refreshIecContact()">
                    @for ( leadTime of leadTimes(); track  leadTime) {
                      <option [ngValue]="leadTime.code">
                        {{ leadTime.description }}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (LeadTimeUtils.validWarrantyLeadTime(order.leadTimeCode, order.brandID)) {
                <label>Warranty</label>
              }
              @if (order.leadTimeCode == 'SLC') {
                <label>Sales Concession</label>
              }
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="rightAligned labelColumn"><label>Sales Channel:</label></td>
            <td class="dataColumn">
              <select name="salesChannelCodeInput" class="inputField" [(ngModel)]="order.salesChannelCode">
                @for (salesChannel of salesChannels(); track salesChannel) {
                  <option [ngValue]="salesChannel.code">
                    {{ salesChannel.description }}
                  </option>
                }
              </select>
            </td>
          </tr>
          <!-- <tr>
          <td></td>
          <td class="rightAligned labelColumn"></td>
          <td class="dataColumn">
            <input name="expeditePartsInput" id="expeditePartsInput" class="checkboxInput" type="checkbox"
              [(ngModel)]="order.expedite"/>
            <label for="expeditePartsInput">Expedite Parts</label>
          </td>
        </tr> -->
        @if (userHasRole('IT') || userHasRole('CustomerService')) {
          <tr>
            <td></td>
            <td class="rightAligned labelColumn"><label>Use Type:</label></td>
            <td class="dataColumn">
              <select name="useTypeCodeInput" class="inputField" [(ngModel)]="order.useTypeCode" #useTypeCodeInput>
                <option value="null" disabled>Please Select</option>
                @for (useType of useTypes(); track useType) {
                  <option [ngValue]="useType.code">{{ useType.description }}</option>
                }
              </select>
            </td>
          </tr>
        }
        <tr>
          <td></td>
          <td class="rightAligned labelColumn"><label>Price Basis Date:</label></td>
          <td class="dataColumn">
            @if (userHasRole('IT')) {
              <div>
                <input [matDatepicker]="priceBasisDatePicker" name="priceBasisDateInput"
                  [value]="formatDisplayDate(order.priceBasisDate)"
                  (dateChange)="setPriceBasisDate($event.value)"/>
                <mat-datepicker-toggle [for]="priceBasisDatePicker"></mat-datepicker-toggle>
                <mat-datepicker id="priceBasisDatePicker" name="priceBasisDatePicker" #priceBasisDatePicker>
                </mat-datepicker>
              </div>
            }
            @if (!userHasRole('IT')) {
              <label>{{ order.priceBasisDate | date:'MM/dd/yyyy':'UTC' }}</label>
            }
          </td>
        </tr>
        <tr>
          <td></td>
          <td class="rightAligned labelColumn"><label>S&amp;H Charge Type:</label></td>
          <td class="dataColumn">
            <div>
              <select name="shipChargeTypeInput" class="inputField" [(ngModel)]="order.shipAndHandChargeType" disabled
                #shipChargeTypeInput>
                <option value="null" disabled>Please Select</option>
                @for (sAndHChargeType of sAndHChargeTypes(); track sAndHChargeType) {
                  <option [ngValue]="sAndHChargeType.code">
                    {{ sAndHChargeType.description }}
                  </option>
                }
              </select>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="infoPanel">
    <div class="panelHeader">
      <label>Shipping Information</label>
    </div>
    <div class="panelBody">
      <table class="layoutTable">
        <tr>
          <td class="rightAligned labelColumn"><label>Ship To:</label></td>
          <td class="dataColumn">
            <span class="addressSelection" (click)="selectAddress()">
              {{ order.overrideShipToAddressLine1 || 'Select' }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Ship Via:</label></td>
          <td class="dataColumn">
            <select name="shipViaCodeInput" class="inputField" [(ngModel)]="order.shipViaCode" (change)="shipViaChange(shipViaCodeInput.value)"  #shipViaCodeInput>
              <option value="null" disabled>Please Select</option>
              @for (shipVia of shipVias(); track shipVia) {
                <option [ngValue]="shipVia.code">{{ shipVia.description }}</option>
              }
            </select>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Requested Ship Date:</label></td>
          <td class="dataColumn">
            <input [matDatepicker]="requestedShipDatePicker" name="requestedShipDateInput"
              [value]="formatDisplayDate(order.requestedShipDate)"
              (dateChange)="setRequestedShipDate($event.value)"/>
            <mat-datepicker-toggle [for]="requestedShipDatePicker"></mat-datepicker-toggle>
            <mat-datepicker id="requestedShipDatePicker" name="requestedShipDatePicker" #requestedShipDatePicker>
            </mat-datepicker>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"></td>
          <td class="dataColumn">
            <input name="acceptEarlyInput" id="acceptEarlyInput" class="checkboxInput" type="checkbox"
              [(ngModel)]="order.acceptEarlyDelivery"/>
            <label for="acceptEarlyInput">Accept Early Delivery</label>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"></td>
          <td class="dataColumn">
            <input name="includeShippingTagsInput" id="includeShippingTagsInput" class="checkboxInput" type="checkbox"
              [checked]="order.includeShippingTags" disabled/>
            <label for="includeShippingTagsInput">Include Shipping Tags</label>
            <mat-icon class="shippingTagInfoIcon" [matTooltip]="getIncludeShippingTagsTooltip()">info_outline</mat-icon>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Advance Notice Hours:</label></td>
          <td class="dataColumn">
            <input name="advanceNoticeHoursInput" class="inputField standardTextBox" maxlength="28"
              [(ngModel)]="order.advanceNoticeHours" #advanceNoticeHoursInput/>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Rep PO#:</label></td>
          <td class="dataColumn">
            <input name="repPoInput" class="inputField standardTextBox" maxlength="15" [(ngModel)]="order.repPo"
              #repPoInput/>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Rep Ref#:</label></td>
          <td class="dataColumn">
            <input name="repRefInput" class="inputField standardTextBox" maxlength="15" [(ngModel)]="order.repRef"
              #repRefInput/>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Primary Contact:</label></td>
          <td class="dataColumn">
            <span [hidden]="order.deliveryContactName || order.deliveryPhone" class="addressSelection"
              (click)="enterContact(true)">
              Enter Contact
            </span>
            <span [hidden]="!(order.deliveryContactName || order.deliveryPhone)" class="addressSelection"
              (click)="enterContact(true)">
              {{ order.deliveryContactName + "; " + order.deliveryPhone }}
            </span>
          </td>
        </tr>
        <tr
          [hidden]="!((order.deliveryContactName || order.deliveryPhone) && (order.deliveryContactName2 || order.deliveryPhone2))">
          <td class="rightAligned labelColumn"><label>Secondary Contact:</label></td>
          <td class="dataColumn">
            <span [hidden]="order.deliveryContactName2 || order.deliveryPhone2" class="addressSelection"
              (click)="enterContact(false)">
              Enter Contact
            </span>
            <span [hidden]="!(order.deliveryContactName2 && order.deliveryPhone2)" class="addressSelection"
              (click)="enterContact(false)">
              {{ order.deliveryContactName2 + "; " + order.deliveryPhone2 }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Delivery Country:</label></td>
          <td class="dataColumn">
            <select name="deliveryCountryInput" class="inputField" [(ngModel)]="order.deliveryCountryCode"
              #deliveryCountryInput>
              <option value="null" disabled>Please Select</option>
              @for (country of deliveryCountries(); track country) {
                <option [ngValue]="country.code">{{ country.description }}
                </option>
              }
            </select>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Mark Cartons:</label></td>
          <td class="dataColumn">
            <input name="markCartonsInput" class="inputField standardTextBox" maxlength="30"
              [(ngModel)]="order.markCartons" #markCartonsInput/>
          </td>
        </tr>
        <tr>
          <td colspan="2">
              <mat-form-field class="input-field fullWidth" appearance="outline" subscriptSizing="dynamic">
                <textarea matInput name="externalNotesInput" rows="3" maxlength="255" class="noresize" [(ngModel)]="order.externalNotes" placeholder="External Notes" #externalNotesInput></textarea>
                <mat-hint align="end">{{(order?.externalNotes?.length || 0) + " / 255"}}</mat-hint>
              </mat-form-field>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div class="thirdColumn">
  <div class="infoPanel">
    <div class="panelHeader">
      <label>Marketing</label>
    </div>
    <div class="panelBody">
      <table class="layoutTable">
        <tr>
          <td class="rightAligned labelColumn"><label>Market Segment:</label></td>
          <td class="dataColumn">
            <div>
              <select name="marketSegmentInput" class="marketingInput" [(ngModel)]="order.marketSegmentCode"
                #marketSegmentInput>
                @for (segment of marketSegments(); track segment) {
                  <option [ngValue]="segment.code">{{ segment.description }}
                  </option>
                }
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Project Type:</label></td>
          <td class="dataColumn">
            <div>
              <select name="projectTypeInput" class="marketingInput" [(ngModel)]="order.projectTypeCode"
                #projectTypeInput>
                @for (projectType of projectTypes(); track projectType) {
                  <option [ngValue]="projectType.code">
                    {{ projectType.description }}
                  </option>
                }
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Spec Type:</label></td>
          <td class="dataColumn">
            <div>
              <select name="specTypeInput" class="marketingInput" [(ngModel)]="order.specTypeCode" #specTypeInput>
                @for (specType of specTypes(); track specType) {
                  <option [ngValue]="specType.code">{{ specType.description }}
                  </option>
                }
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Application Type:</label></td>
          <td class="dataColumn">
            <div>
              <select name="applicationTypeInput" class="marketingInput" [(ngModel)]="order.applicationTypeCode"
                #applicationTypeInput>
                @for (appType of applicationTypes(); track appType) {
                  <option [value]="appType.code">
                    {{ appType.description }}
                  </option>
                }
              </select>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="infoPanel">
    <div class="panelHeader">
      <label>Order Totals</label>
    </div>
    <div class="panelBody">
      <table class="layoutTable">
        <tr>
          <td class="rightAligned labelColumn"><label>Total List:</label></td>
          <td class="dataColumn"><label>{{ order.totalList | currency:'USD' }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Net Amount:</label></td>
          <td class="dataColumn"><label>{{ order.netAmount | currency:'USD' }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><span>Special Quote Amount:</span></td>
          <td class="dataColumn">
            <span>{{ order.specialQuoteAmount | currency: "USD" }}</span>
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Special Charges:</label></td>
          <td class="dataColumn"><label>{{ order.specialCharges  - order.shippingHandlingChargeAmount - order.specialQuoteAmount  - order.partShippingHandlingChargeAmount | currency:'USD' }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Shipping and Handling:</label></td>
          <td class="dataColumn"><label>{{ order.shippingHandlingChargeAmount | currency:'USD' }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Part Shipping and Handling:</label></td>
          <td class="dataColumn"><label>{{ order.partShippingHandlingChargeAmount | currency:'USD' }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Total Order Amount:</label></td>
          <td class="dataColumn"><label>{{ order.totalQuoteAmount | currency:'USD' }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Multiplier:</label></td>
          <td class="dataColumn"><label>{{ order.multiplier | number:'1.4-7' }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Unit Quantity:</label></td>
          <td class="dataColumn"><label>{{ order.unitQuantity }}</label></td>
        </tr>
      </table>
    </div>
  </div>
  <div class="infoPanel">
    <div class="panelHeader">
      <label>Order Status</label>
    </div>
    <div class="panelBody">
      <table class="layoutTable">
        <tr>
          <td class="rightAligned labelColumn"><label>Milestone:</label></td>
          <td class="dataColumn">
            @if (userHasRole('IT') || userHasRole('CustomerService')) {
              <div>
                <select name="milestoneInput" class="inputField" [(ngModel)]="order.milestone" #milestoneInput>
                  @for (milestone of milestones(); track milestone) {
                    <option [ngValue]="milestone.code">{{ milestone.description }}
                    </option>
                  }
                </select>
              </div>
            }
            @if (!userHasRole('IT') && !userHasRole('CustomerService')) {
              <label
              >{{ order.milestoneDescription }}</label>
            }
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Review Status:</label></td>
          <td class="dataColumn"><label>{{ order.reviewStatus }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Approval Status:</label></td>
          <td class="dataColumn"><label>{{ order.approvalStatus }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Order Status:</label></td>
          <td class="dataColumn"><label>{{ order.statusDescription }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Tax Status:</label></td>
          <td class="dataColumn"><label>{{ order.taxStatus }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn">
            <label for="frozenInput">Frozen:</label>
          </td>
          <td class="dataColumn">
            @if (userHasRole('CustomerService') || userHasRole('IT')) {
              <input name="frozenInput"
                id="frozenInput" class="checkboxInput" type="checkbox" [(ngModel)]="order.frozen"/>
            }
            @if (!userHasRole('CustomerService') && !userHasRole('IT')) {
              <label>{{
                order.frozen ? 'Yes' :
                'No'
              }}</label>
            }
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>ERP Status:</label></td>
          <td class="dataColumn">
            @if (userHasRole('CustomerService') || userHasRole('IT')) {
              <input name="erpStatusInput"
                id="erpStatusInput" class="standardTextBox" maxlength="10" [(ngModel)]="order.erpStatus"/>
            }
            @if (!userHasRole('CustomerService') && !userHasRole('IT')) {
              <label>{{ order.erpStatus }}</label>
            }
          </td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Special Status:</label></td>
          <td class="dataColumn"><label>{{ order.sfrStatus }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>FPA Status:</label></td>
          <td class="dataColumn"><label>{{ order.fpaStatus }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Credit Exception:</label></td>
          <td class="dataColumn"><label>{{ creditExceptionDescription() }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Ship Date:</label></td>
          <td class="dataColumn"><label>{{ order.lastConfirmedShipDate | date:'MM/dd/yyyy':'UTC' }} via
          {{ order.shipVia }}</label></td>
        </tr>
        <tr>
          <td class="rightAligned labelColumn"><label>Tracking Number:</label></td>
          <td class="dataColumn"><label>{{ order.trackingNumber }}</label></td>
        </tr>
        <!--<tr *ngIf="showComplexityCategory()">
        <td class="rightAligned labelColumn"><label>Estimated Eng. Effort:</label></td>
        <td class="dataColumn">
          <span class="dataLabel">{{ getComplexityCategory() }}</span>
          <mat-icon color="primary" (click)="showComplexityInformationDialog()" class="size-16 infoIcon">info
          </mat-icon>
        </td>
      </tr>-->
    </table>
  </div>
</div>
</div>
@if (order) {
  <div class="lineToolbar">
    <span class="linesLabel">
      <h3>Order Lines</h3>
    </span>
    <span class="spacer">
    </span>
    <span>
      <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="generateConsolidatedLines()">
        <span>
          <mat-icon class="size-16">reorder</mat-icon>
          @if (!isConsolidatedView) {
            <label class="buttonLabel">Consolidate Lines</label>
          }
          @if (isConsolidatedView) {
            <label class="buttonLabel">Expand Lines</label>
          }
        </span>
      </button>
      @if (order.projectProductType === ProjectProductType.COM && !isStockProgram()) {
        <button matButton="text" class="toolbarButton"
          [disabled]="order.frozen"
          (click)="openRiserChartDialog()">
          <span>
            <mat-icon class="size-16">table_chart</mat-icon>
            <label class="buttonLabel">Riser Chart</label>
          </span>
        </button>
      }
      @if (order.updateAllowed) {
        <button matButton="text" class="toolbarButton"
          [ngClass]="{'skyportTaggingError': taggingRoomMissing()}"
          [disabled]="isBusy()" (click)="openUnitTaggingScreen()">
          <span>
            <mat-icon class="size-16">local_offer</mat-icon>
            <label class="buttonLabel">Tagging</label>
          </span>
        </button>
      }
      @if ((userHasRole('IT') || userHasRole('CustomerService')) && !isStockProgram()) {
        <button matButton="text" class="toolbarButton"
          [disabled]="isBusy()"
          (click)="openLeadTimeDialog()">
          <span>
            <mat-icon class="size-16">today</mat-icon>
            <label class="buttonLabel">Lead Times</label>
          </span>
        </button>
      }
      @if (warrantyLineSummaryActive()) {
        <button matButton="text" class="toolbarButton" [disabled]="isBusy() || getSelectedLineCount() != 1"
          (click)="showWarrantyLineSummary()">
          <span>
            <mat-icon class="size-16">description</mat-icon>
            <label class="buttonLabel">Warranty Details</label>
          </span>
        </button>
      }
      <button matButton="text" class="toolbarButton"
        [disabled]="isBusy() || getSelectedLineCount() != 1 || isConsolidatedView"
        (click)="showLineSummary()">
        <span>
          <mat-icon class="size-16">visibility</mat-icon>
          <label class="buttonLabel">Summary</label>
        </span>
      </button>
      @if (isStockProgram()) {
        <button matButton="text" class="toolbarButton"
          [disabled]="isBusy() || !isSingleStockUnitSelected() || isConsolidatedView"
          (click)="showStockLineSpecifications()">
          <span>
            <mat-icon class="size-16">list_alt</mat-icon>
            <label class="buttonLabel">Specs</label>
          </span>
        </button>
      }
      @if (order.updateAllowed && showCancel()) {
        <button matButton="text" class="toolbarButton"
          [disabled]="isBusy() || getSelectedLineCount() === 0 || isSureFlowUnitSelected() || order.frozen"
          (click)="cancelSelectedLines()">
          <span>
            <mat-icon class="size-16">delete</mat-icon>
            <label class="buttonLabel">Cancel</label>
          </span>
        </button>
      }
      @if (order.updateAllowed && showConfigurator()) {
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()"
          (click)="openConfigurator()">
          <span>
            <mat-icon class="size-16">build</mat-icon>
            <label class="buttonLabel">Configurator</label>
          </span>
        </button>
      }
      @if (canAddLines()) {
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="addParts()">
          <span>
            <mat-icon class="size-16">add</mat-icon>
            <label class="buttonLabel">Parts & Warranty</label>
          </span>
        </button>
      }
      @if (!isStockProgram()) {
        <button matButton="text" class="toolbarButton"
          [disabled]="isBusy() || getSelectedLineCount() === 0 || isSureFlowUnitSelected() || isDiscontinued()"
          (click)="copyLines()">
          <span>
            <mat-icon class="size-16">filter_none</mat-icon>
            <label class="buttonLabel">Copy To</label>
          </span>
        </button>
      }
      @if (canAddRisers()) {
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="addRisers()">
          <span>
            <mat-icon class="size-16">add</mat-icon>
            <label class="buttonLabel">Risers</label>
          </span>
        </button>
      }
    </span>
  </div>
}
@if (order) {
  <div>
    <table class="reportTable fullTableWidth">
      <thead>
        <tr>
          <td class="tableCell headerCell centeredCell">Line</td>
          <td class="tableCell headerCell centeredCell">Product</td>
          <td class="tableCell headerCell centeredCell">Description</td>
          <td class="tableCell headerCell centeredCell">Item Number</td>
          <td class="tableCell headerCell centeredCell">Quantity</td>
          <td class="tableCell headerCell centeredCell">Best Lead Time</td>
          <td class="tableCell headerCell centeredCell">Unit List</td>
          <td class="tableCell headerCell centeredCell">Multiplier</td>
          <td class="tableCell headerCell centeredCell">Final Unit Price</td>
          <td class="tableCell headerCell centeredCell">Final Ext Price</td>
          <td class="tableCell headerCell centeredCell">Customer Item #</td>
          <td class="tableCell headerCell centeredCell">Tags</td>
        </tr>
      </thead>
      @if (consolidatedLines && consolidatedLines.length > 0 && isConsolidatedView) {
        @for (line of consolidatedLines; track line) {
          <tr [class.selectedRow]="isLineSelected(line)"
            [class.incompleteRow]="isIncompleteLine(line)" class="selectableRow"
            >
            <td class="tableCell"></td>
            <td class="tableCell">{{ productColumn(line) }}</td>
            <td class="tableCell">{{ line.description }}</td>
            <td class="tableCell centeredCell"></td>
            <td class="tableCell centeredCell">{{ line.quantity }}</td>
            <td class="tableCell centeredCell"></td>
            <td class="tableCell rightAligned">{{ line.unitList | currency:'USD' }}</td>
            <td class="tableCell centeredCell">{{ line.multiplier | number:'1.4-7' }}</td>
            <td class="tableCell rightAligned"></td>
            <td class="tableCell rightAligned"></td>
            <td class="tableCell">{{ line.customerItemNumber }}</td>
            <td class="tableCell">
            </td>
          </tr>
        }
      }
      @if (order.lines && order.lines.length > 0 && !isConsolidatedView) {
        @for (line of order.lines; track line) {
          <tr [class.selectedRow]="isLineSelected(line)"
            [class.incompleteRow]="isIncompleteLine(line)" class="selectableRow"
            (click)="selectLineRow($event, line)">
            <td class="tableCell">{{ line.lineId }}</td>
            <td class="tableCell">{{ productColumn(line) }}</td>
            <td class="tableCell">{{ line.description }}</td>
            <td class="tableCell centeredCell">{{ line.itemNumber }}</td>
            <td class="tableCell centeredCell">{{ line.quantity }}</td>
            <td class="tableCell centeredCell">{{ line.bestLeadTime }}</td>
            <td class="tableCell rightAligned">{{ line.unitList | currency:'USD' }}</td>
            <td class="tableCell centeredCell">{{ line.multiplier | number:'1.4-7' }}</td>
            <td class="tableCell rightAligned">{{ line.finalUnitPrice | currency:'USD' }}</td>
            <td class="tableCell rightAligned">{{ line.finalExtendedPrice | currency:'USD' }}</td>
            <td class="tableCell">{{ line.customerItemNumber }}</td>
            <td class="tableCell">
              @if (line.tags && line.tags.length > 0) {
                <label>{{
                  line.tags.substring(0, 20) + (line.tags.length > 20 ?
                  '...' : '')
                  }}
                </label>
              }
            </td>
          </tr>
        }
      }
      @if (!order.lines || order.lines.length === 0) {
        <tr>
          <td colspan="11">No lines found</td>
        </tr>
      }
    </table>
  </div>
}
</div>
}
</form>
